<template>
	<div class="notifications">
		<div v-if="records.length">
			<h3>Notifications</h3>
			<div v-for="notification in records" class="flex margin-bottom">
				<div class="flex-grow">
					{{ notification.message }}
				</div>
				<div class="margin-left">
					<button class="white smaller" v-on:click="dismiss(notification.id)">Dismiss</button>
				</div>
			</div>
		</div>

		<template v-if="scheduled_calls.length">
			<h3>Your calls for the day</h3>
			<div v-for="call in scheduled_calls"
				class="flex align-items notification-scheduled-call border-bottom small-padding-bottom small-padding-top last-child-no-border-bottom last-child-no-padding-bottom"
				v-bind:class="{
					flash: flash_call == call.id,
				}">
				<SvgIcon name="phone" />
				<div class="margin-left">
					<strong style="font-size: 18px;">{{ call.call_at.substr(11, 5) }}</strong>
				</div>
				<div class="margin-left" style="width: 80px;">
					{{ call.customer.phone }}
				</div>
				<div class="small-margin-left">
					{{ call.customer.full_name }}
				</div>
				<div class="small-margin-left text-right flex-grow">
					<a :href="'/#/scheduled-call/' + call.id"><button class="smaller white">View call</button></a>
				</div>
			</div>
		</template>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    flash_call: false,
    scheduled_calls: [],
    records: [],
    alreadyNotifiedCall : [],
    notificationsHtmlElement : ""
  }),

  computed: {
    ...mapGetters([
      'getStylist',
      'getNotiSentTime'
    ]),
  },
  methods: {
    dismiss (id) {
      Vue.$api.post('/notification/' + id + '/dismiss', {}, {
        callback: data => this.notifications()
      })
    },

    async notifications() {
        if (this.getStylist.id) {
        await new Promise((resolve, reject) => {
            Vue.$api.get('/notifications', {}, {
            callback: data => {
                this.parseNotifications(data);
                resolve(); // Resolve the promise after notifications are fetched and parsed
            },
            error: error => {
                reject(error); // Reject the promise in case of an error
            },
            });
        });
        }
    },

    parseNotifications (data) {
      this.$store.commit('setNotiSentTime', new Date().getTime())
      this.scheduled_calls = data.scheduled_calls
      this.records = data.notifications
    },
    triggers (data) {
      for (var call of data) {
        var time = ((new Date(call.call_at).getTime()) - (new Date().getTime())) / (1000 * 60)

        if (time > 0 && time < 5) {
          this.trigger(call)
        } else if (call.id == this.flash_call) {
          this.flash_call = false
          this.notificationsHtmlElement.style.display = 'none'
        }
      }
    },
    trigger (call) {
      if(!this.alreadyNotifiedCall.includes(Number(call.id))){
        this.flash_call = call.id;
        this.notificationsHtmlElement.style.display = 'block'
        this.alreadyNotifiedCall.push(Number(call.id));
        this.$emit('push')
      }
      else{
        this.notificationsHtmlElement.style.display = 'none'
      }

      // ... Test with vuex!
    },

    getUpcomingCalls(data) {
        const currentDateTime = new Date(); // Get the current date and time
        const fiveMinutesLater = new Date(currentDateTime.getTime() + 5 * 60000); // Calculate the date and time 5 minutes from now

        const upcomingCalls = data.scheduled_calls.filter(call => {
            const callDateTime = new Date(call.call_at);
            return callDateTime <= fiveMinutesLater;
        });

        return upcomingCalls;
    },

    // call the '/notifications' API every 5 minutes and populate the local properties
    getUpcomingCallsEvery5Minutes() {
        this.notifications();
        setTimeout(()=>{
            this.getUpcomingCallsEvery5Minutes();
        }, 5 * 60000);
    },

    // check every minute if there are any upcoming calls without making any API request
    checkForCurrentCallsEveryMinute() {
        this.triggers(this.scheduled_calls);
        setTimeout(()=>{
            this.checkForCurrentCallsEveryMinute();
        }, 60000);
    }
  },

  mounted(){
        this.notificationsHtmlElement = document.getElementsByClassName('notifications')[0];

        this.notifications().then(() => {
            this.checkForCurrentCallsEveryMinute();
            setTimeout(()=>{
                this.getUpcomingCallsEvery5Minutes();
            }, 5 * 60000);
        });  
    }
}
</script>
